const relativeTime = new Intl.RelativeTimeFormat("en-US", { numeric: "always" });

const UNITS = [
  [365 * 86_400_000, "year"],
  [30 * 86_400_000, "month"],
  [7 * 86_400_000, "week"],
  [86_400_000, "day"],
  [3_600_000, "hour"],
  [60_000, "minute"],
] as const;

/**
 * Human-readable elapsed time, from "just now" through years.
 * Uses completed units (30-day months, 365-day years), supports future dates,
 * and returns an em dash for missing or invalid dates. Pass now for stable output.
 */
export function formatRelativeTime(
  value: Date | string | number | null | undefined,
  now: number = Date.now(),
): string {
  if (value == null || value === "") return "—";
  const timestamp = value instanceof Date ? value.getTime() : new Date(value).getTime();
  const diff = timestamp - now;
  if (!Number.isFinite(diff)) return "—";
  const elapsed = Math.abs(diff);
  if (elapsed < 60_000) return "just now";
  for (const [duration, unit] of UNITS) {
    if (elapsed >= duration) {
      return relativeTime.format(Math.sign(diff) * Math.floor(elapsed / duration), unit);
    }
  }
  return "just now";
}
